import { NgModule } from '@angular/core';
import { IesterComponent } from 'app/integration/iester/iester.component';
import { IntegrationRoutingModule } from 'app/integration/integration-routing.module';
import { CommonModule } from '@angular/common';
import { HedaCoreUtilModule } from '@heda/core-util';
import { MessageLogModule } from 'app/integration/message-log/message-log.module';
import { DocumentModule } from 'app/integration/document/document-module';
import { IesterEntryComponent } from 'app/integration/iester/iester-entry.component';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';

@NgModule({
  imports: [
    IntegrationRoutingModule,
    CommonModule,
    HedaCoreHospitalUiModule,
    HedaCoreUtilModule,
    MessageLogModule,
    DocumentModule,
  ],
  declarations: [IesterComponent, IesterEntryComponent],
  exports: [IesterComponent],
})
export class IntegrationModule {}
